import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-review_action",
  "use": "icon-review_action-usage",
  "viewBox": "0 0 2.489 11.198",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2.489 11.198\" id=\"icon-review_action\"><defs><style>#icon-review_action .a{fill:#505d6f;}</style></defs><path class=\"a\" d=\"M399.466,0a1.244,1.244,0,1,0,1.244,1.244A1.244,1.244,0,0,0,399.466,0Zm-1.244,9.954a1.244,1.244,0,1,0,1.244-1.244A1.244,1.244,0,0,0,398.222,9.954Zm0-4.355a1.244,1.244,0,1,0,1.244-1.244A1.244,1.244,0,0,0,398.222,5.6Z\" transform=\"translate(-398.222)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol